/**
 * Styles for the DateCalendar component
 */
const dateCalendarStyles = () => ({
  '& .MuiDayCalendar-header': {
    display: 'flex',
    justifyContent: 'space-evenly',
    padding: 0,
  },
  '& .MuiDayCalendar-weekDayLabel': {
    fontSize: '0.875rem',
    margin: 0,
  },
  '.MuiDayCalendar-weekContainer': {
    display: 'flex',
    justifyContent: 'space-evenly',
    padding: 0,
    '& .MuiPickersDay-today': {
      border: 'none',
    },
    '& .MuiPickersDay-root': {
      fontSize: '0.875rem',
      margin: 0,
      borderRadius: '0.375rem',
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'rgba(0, 124, 146, 0.04)',
      },
    },
    '& .Mui-selected': {
      backgroundColor: '#007C92 !important',
      '&:hover': {
        backgroundColor: '#007C92',
      },
    },
  },
});

export default dateCalendarStyles;
